import * as React from 'react';

import {
  useHandleChangeWeight,
  useHandleQuestionTextChange,
} from '~teacher/components/QuizQuestion/hooks';
import { QuestionMedia } from '~teacher/components/QuizQuestion/QuestionMedia';
import { proCheck } from '~teacher/util/proCheck';

import {
  QuestionDetails,
  QuestionPoints,
  QuestionText,
  useSelectQuestion,
} from '../QuizQuestion';
import { QuestionMatchingAnswerPairList } from './QuestionMatchingAnswerPairList';

interface Props {
  questionId: string;
  order: number;
  hasCustomGradingWeight: boolean;
  isLocked: boolean;
}

export function QuestionMatching({
  hasCustomGradingWeight,
  order,
  questionId,
  isLocked,
}: Props) {
  const {
    answers,
    explanation,
    explanationImage,
    gradingWeight,
    questionText,
    type,
    isEditing,
  } = useSelectQuestion({ questionId: questionId });
  const showAdvancedQuizEditor = proCheck.canShowAdvancedQuizEditor();
  const handleQuestionTextChange = useHandleQuestionTextChange();

  const handleChangeWeight = useHandleChangeWeight();

  return (
    <div className="question-grid flex-1" data-question={type}>
      <QuestionText
        isLocked={isLocked}
        questionId={questionId}
        order={order}
        text={questionText}
        weight={gradingWeight}
        isEditing={isEditing}
        isDisabled={false}
        placeholder={'Have a matching question to ask?'}
        onQuestionTextChange={handleQuestionTextChange}
        onChangeWeight={handleChangeWeight}
        showAdvancedQuizEditor={showAdvancedQuizEditor}
      />
      <QuestionMedia questionId={questionId} />
      <div
        className={`lg:row-start-2 ${isEditing ? 'mt-4 -mr-12 md:mr-0' : ''}`}
      >
        <QuestionPoints
          isHidden={!hasCustomGradingWeight || isEditing}
          weight={gradingWeight}
        />
        {__DEV__ && (
          <QuestionMatchingAnswerPairList
            answerIds={answers}
            isEditing={isEditing}
          />
        )}
        <QuestionDetails
          isDisabled={false}
          questionId={questionId}
          content={explanation}
          image={explanationImage}
          isEditing={isEditing}
        />
      </div>
    </div>
  );
}
